// Removed IE11 polyfills (react-app-polyfill) - not needed in 2026
import React from "react";
import ReactDOM from "react-dom/client";
// import ReactDOM from "react-dom";
import { BrowserRouter as Router, Route } from "react-router-dom";
import "./index.css";
import App from "./App";
import store from "./app/store";
import { Provider } from "react-redux";
import { ThemeProvider } from "./contexts/ThemeContext";
// import * as serviceWorker from "./serviceWorker";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error('Root element with id "root" not found');
}

const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <Router>
        <Provider store={store}>
          <Route path='/:lang?' render={(props) => <App {...props} />} />
        </Provider>
      </Router>
    </ThemeProvider>
  </React.StrictMode>
);

// If you were using serviceWorker, hook it here (optional):
// serviceWorker.unregister();
// or
// serviceWorker.register();
